function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as $constants from '@/utils/constants';
import { checkPermi } from '@/utils/permission';
export default {
  name: 'BaseTable',
  props: {
    // 表格数据
    tableData: {
      type: Object,
      default: function _default() {
        return {
          data: [],
          total: 0
        };
      }
    },
    // 表格列配置
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 加载状态
    loading: {
      type: Boolean,
      default: false
    },
    // 表格尺寸
    size: {
      type: String,
      default: 'mini',
      validator: function validator(value) {
        return ['medium', 'small', 'mini'].indexOf(value) !== -1;
      }
    },
    // 表格高度
    height: {
      type: [String, Number],
      default: 'auto'
    },
    // 行标识
    rowKey: {
      type: String,
      default: 'id'
    },
    // 是否高亮当前行
    highlightCurrentRow: {
      type: Boolean,
      default: true
    },
    // 是否显示多选
    showSelection: {
      type: Boolean,
      default: false
    },
    // 多选列宽度
    selectionWidth: {
      type: [String, Number],
      default: 50
    },
    // 是否显示展开列
    expandRow: {
      type: Boolean,
      default: false
    },
    // 展开列宽度
    expandWidth: {
      type: [String, Number],
      default: 40
    },
    // 是否显示分页
    showPagination: {
      type: Boolean,
      default: true
    },
    // 分页配置
    pagination: {
      type: Object,
      default: function _default() {
        return {
          pageNum: 1,
          pageSize: 10
        };
      }
    },
    // 分页器布局
    paginationLayout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    // 每页大小选项
    pageSizes: {
      type: Array,
      default: function _default() {
        return $constants.page.limit;
      }
    },
    // 自定义表格属性
    tableProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 多选过滤函数
    selectable: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    // 标签页配置
    tabs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 当前激活的标签页
    activeTab: {
      type: [String, Number],
      default: ''
    },
    // 标签页类型
    tabType: {
      type: String,
      default: 'card',
      validator: function validator(value) {
        return ['card', 'border-card'].indexOf(value) !== -1;
      }
    },
    // 标签页是否可关闭
    tabClosable: {
      type: Boolean,
      default: false
    },
    // 标签页是否可添加
    tabAddable: {
      type: Boolean,
      default: false
    },
    checkedList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    activeTab: {
      handler: function handler(newVal) {
        this.activeTabNew = newVal;
      },
      deep: true
    },
    'tableData.data': {
      handler: function handler(val) {
        var _this = this;
        this.$nextTick(function () {
          _this.setSelectRow();
          //  this.setSelection();
        });
      },
      deep: true
    }
  },
  data: function data() {
    return {
      activeTabNew: this.activeTab,
      multipleSelection: [],
      multipleSelectionAll: [],
      idKey: 'id'
    };
  },
  emits: ['selection-change', 'row-click', 'row-dblclick', 'size-change', 'current-change', 'tab-click', 'tab-remove', 'tab-add', 'switch-change'],
  mounted: function mounted() {
    var _this2 = this;
    if (!this.checkedList) return;
    this.checkedList.forEach(function (row) {
      _this2.$refs.table.toggleRowSelection(row);
    });
  },
  methods: {
    checkPermi: checkPermi,
    // 处理选择变更
    handleSelectionChange: function handleSelectionChange(selection) {
      var _this3 = this;
      this.multipleSelection = selection;
      setTimeout(function () {
        _this3.$selfUtil.changePageCoreRecordData(_this3.multipleSelectionAll, _this3.multipleSelection, _this3.tableData.data, function (e) {
          _this3.multipleSelectionAll = e;
          _this3.$emit('selection-change', _this3.multipleSelectionAll);
        });
      }, 50);
    },
    // 设置选中的方法
    setSelectRow: function setSelectRow() {
      if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
        return;
      }
      // 标识当前行的唯一键的名称
      var idKey = this.idKey;
      var selectAllIds = [];
      this.multipleSelectionAll.forEach(function (row) {
        selectAllIds.push(row[idKey]);
      });
      this.$refs.table.clearSelection();
      for (var i = 0; i < this.tableData.data.length; i++) {
        if (selectAllIds.indexOf(this.tableData.data[i][idKey]) >= 0) {
          // 设置选中，记住table组件需要使用ref="table"
          this.$refs.table.toggleRowSelection(this.tableData.data[i], true);
        }
      }
    },
    // 处理行点击
    handleRowClick: function handleRowClick(row, column, event) {
      this.$emit('row-click', row, column, event);
    },
    // 处理行双击
    handleRowDblClick: function handleRowDblClick(row, column, event) {
      this.$emit('row-dblclick', row, column, event);
    },
    // 处理每页大小变更
    handleSizeChange: function handleSizeChange(size) {
      var _this4 = this;
      this.$selfUtil.changePageCoreRecordData(this.multipleSelectionAll, this.multipleSelection, this.tableData.data, function (e) {
        _this4.multipleSelectionAll = e;
      });
      this.$emit('size-change', size);
    },
    // 处理页码变更
    handleCurrentChange: function handleCurrentChange(current) {
      var _this5 = this;
      this.$selfUtil.changePageCoreRecordData(this.multipleSelectionAll, this.multipleSelection, this.tableData.data, function (e) {
        _this5.multipleSelectionAll = e;
      });
      this.$emit('current-change', current);
    },
    // 清空选择
    clearSelection: function clearSelection() {
      this.$refs.table.clearSelection();
    },
    // 切换行选中状态
    toggleRowSelection: function toggleRowSelection(row, selected) {
      this.$refs.table.toggleRowSelection(row, selected);
    },
    // 切换全选状态
    toggleAllSelection: function toggleAllSelection() {
      this.$refs.table.toggleAllSelection();
    },
    // 设置当前行
    setCurrentRow: function setCurrentRow(row) {
      this.$refs.table.setCurrentRow(row);
    },
    // 获取表格引用
    getTableRef: function getTableRef() {
      return this.$refs.table;
    },
    // 处理标签页点击
    handleTabClick: function handleTabClick(tab, event) {
      this.$emit('tab-click', this.activeTabNew);
    },
    // 处理标签页移除
    handleTabRemove: function handleTabRemove(tabName) {
      this.$emit('tab-remove', tabName);
    },
    // 处理标签页添加
    handleTabAdd: function handleTabAdd() {
      this.$emit('tab-add');
    },
    // 处理开关状态变化
    handleSwitchChange: function handleSwitchChange(row, value, column) {
      this.$emit('switch-change', row);
    },
    // 回显选中状态
    setSelection: function setSelection() {
      var _this6 = this;
      if (!this.checkedList || this.checkedList.length === 0) return;
      if (!this.tableData.data || this.tableData.data.length === 0) return;
      this.$nextTick(function () {
        _this6.tableData.data.forEach(function (row) {
          var key = _this6.rowKey || 'id';
          var rowId = row[key];
          var isChecked = _this6.multipleSelection.some(function (checkedItem) {
            if (_typeof(checkedItem) === 'object' && checkedItem !== null) {
              return checkedItem[key] === rowId;
            } else {
              return checkedItem === rowId;
            }
          });
          if (isChecked) {
            _this6.$refs.table.toggleRowSelection(row, true);
          }
        });
      });
    }
  }
};